import { IFormProps, withForm } from "@ui/components/forms";
import MealConsumed from "../MealConsumed";

const MealConsumedForm = ({ Wrapper }: IFormProps) => {
  return (
    <Wrapper title={"Meal Consumed Summary"} footer={() => undefined}>
      <MealConsumed />
    </Wrapper>
  );
};

const MealConsumedFormHOC = withForm<any, any>(MealConsumedForm);
export default MealConsumedFormHOC;
